import React, { useState, useContext, useEffect } from 'react';
import { GlobalContext } from '../../providers/GlobalProvider';
import FullRecord from './FullRecord';
import DataSearchAPI from '../../api/DataSearch';
import { Modal } from '@mui/material';
import CommoditiesWorkflow from 'components/Screening/mainTabComponents/CommoditiesWorkflow';
interface ITariff {
  primary?: string;
  country?: string;
  isSelected?: boolean;
  isExpands?: boolean;
  resultsOnly?: boolean;
  workflowResults?: any;
  autoOpenFirstLens?: boolean;
  defaultResultLevel?: 2 | 3;
  onTrialLimitReached?: () => void;
}

const ImportWorkflowScreening: React.FC<ITariff> = ({
  primary,
  country,
  isSelected,
  isExpands,
  resultsOnly,
  workflowResults,
  autoOpenFirstLens,
  defaultResultLevel,
  onTrialLimitReached,
}) => {
  const [showFullRecord, setShowFullRecord] = useState({
    show: false,
    record: {},
  });
  const [showFilters, setShowFilters] = useState(true);

  // stripe
  const [userHasCommoditySearch, setUserHasCommoditySearch] = useState(false);

  const { cur_user, ticketDraft } = useContext(GlobalContext);

  // inputs
  const [commodityInputs, setCommodityInputs] = useState<any>({
    hsCode: primary
      ? primary
      : ticketDraft.commodity?.harmonizedScheduleCode
      ? ticketDraft.commodity?.harmonizedScheduleCode
      : '',
    desc: '',
    origin: country ? country : '',
    destination: 'USA',
  });

  const [commodityPage, setCommodityPage] = useState<number>(0);

  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [commodityState, setCommodityState] = useState({
    fuzzy: true,
    date: null,
    dateRange: [],
    comLenses: [],
    comFilters: [],
    chapters: [],
    sections: [],
    codes: [],
    countries: [],
    agencies: [],
    lists: [],
    hsCodeLists: [],
  });

  const requiredTiers = ['starter', 'pro', 'business', 'enterprise'];

  const checkForCommoditySearch = () => {
    if (
      requiredTiers.some((role) =>
        cur_user.selected_team?.attributes?.tier.includes(role),
      )
    ) {
      setUserHasCommoditySearch(true);
    }
  };

  useEffect(() => {
    checkForCommoditySearch();
  }, []);

  useEffect(() => {
    if (primary && country) {
      if (primary) {
        setCommodityInputs({
          hsCode: primary
            ? primary
            : ticketDraft.commodity?.harmonizedScheduleCode
            ? ticketDraft.commodity?.harmonizedScheduleCode
            : '',
          desc: '',
          origin: '',
          destination: 'USA',
        });
      }
    }
  }, [primary, country]);

  const getFilters = async () => {
    const mongoReq = {
      query: {
        groupId: cur_user?.selected_team?.id,
        userId: cur_user?.basics?.id,
      },
    };
    const res = await DataSearchAPI.getUserSearchFilters(mongoReq);
    if (res?.success) {
      const comListArr: any = [];
      const comCodeArr: any = [];

      res.result.forEach((filt: any) => {
        if (filt.type === 'commodityCode') {
          comCodeArr.push(filt);
        } else if (filt.type === 'commodityList') {
          comListArr.push(filt);
        }
      });
    }
  };

  useEffect(() => {
    getFilters();
  }, []);

  return (
    <>
      <CommoditiesWorkflow
        userHasCommoditySearch={userHasCommoditySearch}
        cur_user={cur_user}
        setShowFullRecord={setShowFullRecord}
        showFilters={showFilters}
        setShowFilters={setShowFilters}
        inputs={commodityInputs}
        page={commodityPage}
        setPage={setCommodityPage}
        commodityState={commodityState}
        isSelected={isSelected}
        isExpands={isExpands}
        resultsOnly={resultsOnly}
        workflowResults={workflowResults}
        autoOpenFirstLens={autoOpenFirstLens}
        defaultResultLevel={defaultResultLevel}
        onTrialLimitReached={onTrialLimitReached}
      />
      <Modal
        open={showFullRecord.show}
        onClose={() => setShowFullRecord({ show: false, record: {} })}
      >
        <FullRecord
          setShowFullRecord={setShowFullRecord}
          showFullRecord={showFullRecord}
        />
      </Modal>
    </>
  );
};

export default ImportWorkflowScreening;
